import { render, staticRenderFns } from "./TerminalSelects.vue?vue&type=template&id=85c4f38e&"
import script from "./TerminalSelects.vue?vue&type=script&lang=js&"
export * from "./TerminalSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports